<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import upprocess from "../../../../common/upProcess/index.vue";
import uploadFile from "../../../../common/uploadFile/index.vue";
import updateywkm from "../../../../common/updateywkm/index.vue";
import { kydkpz_upload } from "../../../../../api/kydkpz.js";
import config from "../../../../../../configHttp.js";
import {importTaxOfficeTemplate} from "../../../../../api/sjmb";
export default {
  components: {
    upprocess,
    uploadFile,
    updateywkm,
  },
  data: function () {
    return {
      uptype: 1,
      mboptions: getdata().mboptions,
	  typeing:getdata().typeing,
	  uploadData:{
		    importType: "0",
			 tabType:"0"
			},
      count: 5,
      // successCount:0,
      successdata: { successCount: 0, errorCount: 0 },
      batchNum: "",
      // timer:null,
      upformdata: {}, //文件信息
    };
  },
  methods: {
    forbackup() {
      this.$refs["uploadfileRef"].forrefresh();
      this.uptype = 1;

      clearInterval(this.timer);
    },
    forchooseindex(index) {
      this.$emit("forchooseindex", index);
    },
    toCustomTemplate() {
      this.$router.push("/CustomTemplate");
    },
    getuploadparams(e) {
      this.upformdata = e;
      // 获取到的文件信息
    },
    fordownloadmb() { //模板下载
      let fileName;
      let url;
      let fileType;
      if (this.uploadData.importType === "2") {
        fileName = "税局导入模板";
        url = "dataAcquisition/template/download";
        fileType = "xlsx";
      } else {
        fileName = "客运抵扣凭证导入模板";
        url = "kydk/template/download";
        fileType = "zip";
      }
      let params = {
        downUrl: config.baseURL + url,
        typeObj: {
          toForm: false,
          fileName: fileName + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: fileType,
          failUrl: this.$winURl
        },
      };
      this.$downloadcommon(params);
    },
    importIinvExcel() {
      this.count = 5;
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }
      this.uploadData.file = this.upformdata.upfile;
      if (this.uploadData.importType === "2") {
        if (this.uploadData.tabType !== "1" && this.uploadData.tabType !== "3") {
          this.$message.error("仅支持航运行程单/火车票进行税局模板导入");
          return false;
        }
        importTaxOfficeTemplate(this.uploadData).then(res => {
          if (this.uploadData.tabType === "1") {
            if (!res.data.data.TRAVEL_PLANE) {
              this.$message.error("当前导入文件没有航运行程单数据");
              return false;
            }
            // 行程单
            this.importResultHandle(res.data.code, res.data.data.TRAVEL_PLANE.batchNo, res.data.data.TRAVEL_PLANE, res.data.msg);
          } else if (this.uploadData.tabType === "3") {
            // 火车票
            if (!res.data.data.TRAVEL_TRAIN) {
              this.$message.error("当前导入文件没有火车票数据");
              return false;
            }
            this.importResultHandle(res.data.code, res.data.data.TRAVEL_TRAIN.batchNo, res.data.data.TRAVEL_TRAIN, res.data.msg);
          }
        })
      } else {
        kydkpz_upload(this.uploadData).then((res) => {
          this.importResultHandle(res.data.code, res.data.data.batchNo, res.data.data, res.data.msg);
        });
      }
    },
    importResultHandle(code, batchNum, successdata, errMsg) {
      if (code == 1) {
        //如果成功数量为0则跳转至结果页面
        if (successdata.successCount == 0 || !successdata.successCount) {
          this.$message.error(
              "当前导入文件成功条数为0，具体错误信息可到上传结果界面查看"
          );
        } else {
          this.uptype = 2;
          this.batchNum = batchNum;
          this.successdata = {
            successCount: successdata.successCount,
            errorCount: successdata.errorCount,
          };
          // this.getSubjectCompanys()
          this.timer = setInterval(() => {
            this.count--;
            if (self._isDestroyed) {
              clearInterval(this.timer);
              return false;
            }
            if (this.count == 0) {
              this.$refs["uploadfileRef"].forrefresh();
              this.uptype = 1;
              clearInterval(this.timer);
            }
          }, 1000);
        }
      } else {
        this.$message.error(errMsg);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
